import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { TrainingClass } from './training-class';
export { TrainingClass };
import { trainingClassSchema } from '@schemas/business-objects/training-class';
import { ClassEnrollmentFormArray } from './class-enrollment-form-group';
import { UserFormGroup } from './user-form-group';
import { VenueFormGroup } from './venue-form-group';

export class TrainingClassFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    startDate: SchemaFormControl;
    endDate: SchemaFormControl;
    venueId: SchemaFormControl;
    venue: VenueFormGroup;
    instructorId: SchemaFormControl;
    instructor: UserFormGroup;
    classEnrollments: ClassEnrollmentFormArray;
  };

  declare value: Partial<TrainingClass>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(trainingClassSchema, TrainingClass, data, options);
  }

  get object(): TrainingClass {
    return new TrainingClass(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'venue':
        return new VenueFormGroup();
      case 'instructor':
        return new UserFormGroup();
      case 'classEnrollments':
        return new ClassEnrollmentFormArray();
      default:
        return undefined;
    }
  }
}

export class TrainingClassFormArray extends PersistedFormArray {
  readonly entityName = 'TrainingClass' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(trainingClassSchema, TrainingClass, options);
  }

  protected override createItemGroup() {
    return new TrainingClassFormGroup();
  }

  get array(): TrainingClass[] {
    return this.controls.map((group: TrainingClassFormGroup) => group.object);
  }
}

export class TrainingClassPersistedArray extends PersistedArray<TrainingClass> {
  readonly entityName = 'TrainingClass' as const;

  constructor(options?: PersistedArrayOptions) {
    super(TrainingClass, options);
  }
}
